import { Reducer } from "redux";

import {
    POST_CREATE_FETCH_FAILURE,
    POST_CREATE_FETCH_REQUEST,
    POST_CREATE_FETCH_SUCCESS,
    POST_CREATE_SET_WANTS_MK_TO_FOUND_DISCUSSION,
    PostCreateFetchFailureAction,
    PostCreateFetchRequestAction,
    PostCreateFetchSuccessAction,
    PostCreateSetWantsMkToFoundDiscussionAction,
} from "@/mk2/apps/forum/containers/PostCreate/PostCreate.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface PostCreateState {
    loadingState: LoadingState;
    errorMessage: string;
    topicId: number;
    wantsMkToFoundDiscussion: boolean;
}

const initialPostCreateState: PostCreateState = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
    topicId: null,
    wantsMkToFoundDiscussion: false,
};

type PostCreateReducerActions =
    | PostCreateFetchRequestAction
    | PostCreateFetchSuccessAction
    | PostCreateFetchFailureAction
    | PostCreateSetWantsMkToFoundDiscussionAction;

const postCreateReducer: Reducer<PostCreateState, PostCreateReducerActions> = (
    state = initialPostCreateState,
    action,
) => {
    switch (action.type) {
        case POST_CREATE_FETCH_REQUEST:
        case POST_CREATE_FETCH_FAILURE: {
            return tupdate(state, {
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
                topicId: null,
            });
        }

        case POST_CREATE_FETCH_SUCCESS: {
            return tupdate(state, {
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
                topicId: action.response.result.topic,
            });
        }

        case POST_CREATE_SET_WANTS_MK_TO_FOUND_DISCUSSION: {
            return tupdate(state, {
                wantsMkToFoundDiscussion: action.enabled,
            });
        }

        default:
            return state;
    }
};

export default postCreateReducer;
